import React from 'react'
import classNames from 'classnames'

import CategoryLink from '../categoryLink'

const TopLevelMenu = ({ item }) => {
  const hasChildren = item.children.length > 0
  const isNew = item.isNew
  const linkClassName = classNames('-rounded-corners', {
    'header-categories__main-link': hasChildren,
    'header-categories__main-link--empty': !hasChildren,
    'header-categories__main-link--new-label': hasChildren && isNew,
    'header-categories__main-link--empty--new-label': !hasChildren && isNew
  })

  return (
    <li className='header-categories__links-item'>
      <CategoryLink to={item.url} className={linkClassName}>
        {item.name + ' '}
        {isNew && <span className='e-text-label -size-s -color-grey-light'>New</span>}
      </CategoryLink>
      {hasChildren && <SubLevelMenu items={item.children} />}
    </li>
  )
}

const SubLevelMenu = ({ items }) => {
  return (
    <div className='header-categories__links-dropdown'>
      <ul className='hub-header-dropdown'>
        {items.map((item, key) => {
          const isTop = item.isTop
          const isBottom = item.isBottom
          const linkClassName = classNames({
            'hub-header-dropdown__top': isTop,
            'hub-header-dropdown__bottom': isBottom
          })
          return (
            <li className={linkClassName} key={key}>
              <CategoryLink to={item.url}>
                {item.name + ' '}
              </CategoryLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const CategoriesMenu = ({ items }) => {
  return (
    <ul className='header-categories__links'>
      {items.map((item, key) => {
        return <TopLevelMenu key={key} item={item} />
      })}
    </ul>
  )
}

export default CategoriesMenu



// WEBPACK FOOTER //
// ./client/components/siteHeader/categoriesMenu.js